import Vue from 'vue'
import App from './App.vue'

import VueI18n from 'vue-i18n'

import Axios from 'axios'

//VUEX
import store from './store/store'

Vue.prototype.$http = Axios;

Vue.config.productionTip = false

let messages = require('./localization/translations.json')

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: "pt-BR", // set locale
  messages
})

const app = new Vue({
  store,
  el: '#app',
  i18n,
  http: {
      emulateJSON: true,
      emulateHTTP: true
  },  
  render: h => h(App),    
});

window.app = app;
// window.app.$bsml = window.bsml;